import { PropsWithChildren } from 'react'

import { Operation, ResourceType, usePermission } from '@/permissions'
import { useUsersMeRetrieve } from '@api'

interface Props {
  resourceType: ResourceType
  operation?: Operation
}

interface CountryPermitProps {
  resourceType: ResourceType
  operation?: Operation
  allowedCountryCodes: string[] // ISO 3166-1 alpha-2 想定.
}

/** 権限がある場合のみ children を表示 */
export const Permit = ({
  resourceType,
  operation = 'READ',
  children,
}: PropsWithChildren<Props>) => {
  const { permitted } = usePermission()
  return <>{permitted(resourceType, operation) && children}</>
}

/**
 * 国コードベースでアクセス制御を行うコンポーネント
 * Permit コンポーネントをラップし、ユーザーの国コードが許可リストに含まれる場合のみ Permit コンポーネントを表示
 * アクセス拒否の場合は Permit コンポーネントと同様に何も表示しない
 */
export const CountryPermit = ({
  resourceType,
  operation = 'READ',
  allowedCountryCodes,
  children,
}: PropsWithChildren<CountryPermitProps>) => {
  const { data: user } = useUsersMeRetrieve()

  if (!user) {
    return null
  }

  const match = (code: string) => code.toLowerCase() === user.country_code

  if (!allowedCountryCodes.some(match)) {
    return null
  }

  return (
    <Permit resourceType={resourceType} operation={operation}>
      {children}
    </Permit>
  )
}
